module.exports = __webpack_public_path__ + "media/images/pages/a-level/a-level-certificate-101e0b1374d0c7a7a1f116c6a23ae178.svg";